import React from 'react';
import PropTypes from 'prop-types';
import './InfoBox.scss';

const InfoBox = ({
    setActiveArea,
    position,
    windowWidth,
    alignment = 'left',
    year1,
    year2,
    notice,
    title,
    text,
}) => {
    const style = {
        [windowWidth > 1150 ? 'top' : 'bottom']:
            windowWidth > 1150 ? position[0] : 'auto',
        [windowWidth > 1150 ? alignment : 'left']:
            windowWidth > 1150 ? position[1] : 'auto',
    };

    return (
        <div className="InfoBox" style={style}>
            <button
                className="InfoBox__Close"
                onClick={() => setActiveArea(null)}
            />
            {year1.title &&
                <div className="InfoBox__Year">
                    <span className="InfoBox__YearText" data-subtitle={year1.subtitle}>{year1.title}</span>
                    {year2.title &&
                        <>
                            -<span className="InfoBox__YearText" data-subtitle={year2.subtitle}>{year2.title}</span>
                        </>
                    }
                </div>
            }
            <div className="InfoBox__Notice">{notice}</div>
            <div className="InfoBox__Content">
                <h3 className="InfoBox__Title">{title}</h3>
                <p className="InfoBox__Text">{text}</p>
            </div>
        </div>
    );
};

InfoBox.propTypes = {
    setActiveArea: PropTypes.func,
    position: PropTypes.array,
    windowWidth: PropTypes.number,
    alignment: PropTypes.string,
    year1: PropTypes.object,
    year2: PropTypes.object,
    notice: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    image: PropTypes.any,
};

InfoBox.defaultProps = {
    position: [0, 0],
    alignment: 'left',
    year1: {},
    year2: {},
    notice: '',
    title: '',
    text: '',
    image: {},
};

export default InfoBox;
